import React, {useEffect, useLayoutEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Form from "~/common/components/Form";

import ViewQna from "./viewComponent/viewQna";
import ViewInquery from "./viewComponent/viewInquery";

// assets
import "~/assets/sass/pages/applyFormMange/insertApplyForm.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { useGlobalStore } from "~/store";
import useAlert from "~/common/hooks/useAlert";
import SingleImageUploader from "~/common/components/ImageUploader/SingleImageUploader";
import { UPLOAD_TYPE } from "~/common/constants/upload";
import { ROUND_SUBMIT } from "~/common/components/ImageUploader/ImagePath";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Select from "~/common/components/Select";
import Processing from "~/pages/review/processingModal/Processing";
import ProcessAlerts from "~/pages/review/processingModal/ProcessAlerts";

const InsertApplyForm = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [
		{
			user: { company },
			sidebar: { authMap },
		},
	] = useGlobalStore();
	const currentPath = authMap?.main?.apply?.form;



	const [applyQuestList, setApplyQuestList] = useState({});
	const [showShareAlert, ShareAlert] = useAlert();
	const [showAuthAlert, AuthAlert] = useAlert();
	const [showCopyCheckAlert, CopyCheckAlert] = useAlert();
	const [showCopyCheckReviewAlert, CopyCheckReviewAlert] = useAlert();
	const [showApplyTitleAlert, ApplyTitleAlert] = useAlert();

	const [bannerImg, setBannerImg] = useState("");

	// 심사항목
	const [settingList, setSettingList] = useState([{ label: "선택 안함", value: 0 }]);

	// api
	const listRequest = useRequest("get", "vc/apply/template");
	const applyRegRequest = useRequest("post", "/vc/apply/template");
	const settingCreateRequest = useRequest("post", "/vc/round/setting/add");

	// 심사항목 조회
	const settingListRequest = useRequest("get", "/vc/round/setting/list");
	const [roundItemModal, setRoundItemModal] = useState(false); // 심사항목 팝업
	const [deleteAlertModal, setDeleteAlertModal] = useState(false);
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingDetail, setSettingDetail] = useState({});
	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");


	const applyForm = useForm();


	useEffect(() => {
		listRequest.singleCall();
	}, []);

	const changeBannerImg = (img) => {
		if (currentPath !== "edit") {
			showAuthAlert();
			return;
		}
		setBannerImg(img);

		applyRegRequest.call(
			{
				...applyQuestList,
				image: {
					name: "",
					path: img,
					size: 0,
				},
			},
			"body"
		);
	};
	useEffect(() => {
		setBannerImg(applyQuestList?.image?.path);
	}, [applyQuestList]);

	// const copyClipBoard = async (idx) => {
	// 	try {
	// 		await navigator.clipboard.writeText(`${window.location.origin}/startup/apply/${idx}`);
	// 		showShareAlert();
	// 	} catch (error) {
	// 		console.log("error > ", error);
	// 		alert(t("pages.applyFormMange.ApplyForm.copyClipBoard"));
	// 	}
	// };

	const copyClipBoard = async (idx) => {
		try {
			const copyText = `${window.location.origin}/startup/apply/${idx}`;
			if(navigator.clipboard && window.isSecureContext) {
				console.log('navigator clipboard copy');
				navigator.clipboard
					.writeText(copyText)
					.then(() => {showShareAlert()})
					.catch((err) => { console.log("err -> ", err) });
			} else {
				try {
					console.log('copy exec command use');

					const textarea = document.createElement("textarea");
					textarea.value = copyText;
					textarea.style.top = 0;
					textarea.style.left = 0;
					textarea.style.position = "fixed";
					document.body.appendChild(textarea);
					textarea.focus();
					textarea.select();

					const copyExec = document.execCommand('copy');
					document.body.removeChild(textarea);

					if(copyExec) showShareAlert();
					else { console.log("error") }
				} catch (err) {
					console.log("error", err)
				}
			}
		} catch (error) {
			console.log("error > ", error);
			alert(t("pages.applyFormMange.ApplyForm.copyClipBoard"));
		}
	};

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestApplyList = listRequest.response?.data;

				setApplyQuestList(requestApplyList.template);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	// ##### useEffect
	//심사항목
	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};

	useEffect(() => {
		switch (settingListRequest.state) {
			case API_STATE.done:
				const listData = [];
				// setItemList(settingListRequest.response?.data?.list);
				settingListRequest.response?.data?.list?.map((d) =>
					listData.push({ label: d.title, value: d.idx })
				);
				if(applyQuestList?.reviewSettingIdx) {
					// const filterReview = settingList.filter(item => item.value === applyQuestList?.reviewSettingIdx);
					// if(filterReview?.length > 0) {
					// 	applyForm.setValue("reviewSettingIdx", filterReview[0]?.value);
					// }
					applyForm.setValue("reviewSettingIdx", applyQuestList?.reviewSettingIdx);
				}
				setSettingList(listData);
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingListRequest.state, settingListRequest.error, settingListRequest.response]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				setRoundItemModal(false);
				settingListRequest.call();
				listRequest.call();
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);

	useEffect(() => {
		switch (applyRegRequest.state) {
			case API_STATE.done:
				listRequest.call();
				break;
			case API_STATE.error:
				break;
			default:
				break;
		}
	}, [applyRegRequest.state, applyRegRequest.response, applyRegRequest.error]);

	useLayoutEffect(() => {
		settingListRequest.singleCall();
	}, []);

	const value = applyForm.watch("reviewSettingIdx");

	useEffect(() => {
		if(value) {
			if(value !== applyQuestList?.reviewSettingIdx) {
				applyRegRequest.call(
					{
						...applyQuestList,
						reviewSettingIdx: value
					},
					"body"
				);
			}
		}
	}, [value])

	return (
		<>
			<Helmet>
				<title>{getTitle(t("pages.applyFormMange.ApplyForm.title"))}</title>
			</Helmet>
			<div className="p__apply-InsertForm">
				{/* empty page */}
				{/*<div className="page-init">*/}
				{/*	<p className="main">생성된 Apply 양식이 없습니다.</p>*/}
				{/*	<p className="sub">*/}
				{/*		우측 상단의 양식 등록하기 버튼을 클릭하여 양식을 생성해주세요.*/}
				{/*	</p>*/}
				{/*	<button type="button" className="btn__solid" color="primary">*/}
				{/*		등록하기*/}
				{/*	</button>*/}
				{/*	<img src={lightInitImg} alt="초기이미지" />*/}
				{/*</div>*/}

				{/*	detail page */}
				<div className="apply-form-group">
					<div className="apply-sticky-card">
						<div className="card">
							<div className="f__control">
								<SingleImageUploader
									uploaderConstant={UPLOAD_TYPE.COMMON}
									setImg={changeBannerImg}
									img={bannerImg}
									path={ROUND_SUBMIT}
									name="inquiryImg"
									notice={"Apply 양식 수정 후 등록해주세요."}
									apply
								/>
							</div>
						</div>
						<div className={"card review_card"}>
							<div className={"card-header"}>
								<h3 className="title required">심사항목 선택</h3>
								<p className="notice">Apply 양식 수정 후 선택해주세요.</p>
							</div>

							<Form useForm={applyForm} className={"light"}>
								{
									settingList &&
									<Select
										label={t("pages.investment.InvestEvalPage.evalRequest.contents.RequestForm.label02")}
										name="reviewSettingIdx"
										options={settingList}
										placeholder={settingList.filter(item => item.value === applyQuestList?.reviewSettingIdx)?.[0]?.label}
										required
									/>
								}
							</Form>
							<div className="explain-box">
								<p className="main">※ 신규 등록이 필요한 경우 아래 심사항목 신규 등록을 클릭해주세요.</p>
								<button className={"btn_register"} onClick={() => setRoundItemModal(true)}>
									심사 항목 신규 등록
								</button>
							</div>
						</div>
					</div>


					{/* apply form */}
					<div className="apply-form-card">
						{/*	수정하기 버튼 */}
						<div className="btn-group">
							<button
								type="button"
								className="btn__outline apply-edit-btn"
								color="primary"
								onClick={() => {
									if (currentPath !== "edit") {
										showAuthAlert();
										return;
									}
									navigate("/applyForm/edit");
								}}
							>
								{t("pages.applyFormMange.ApplyForm.apply-edit-btn")}
							</button>
							<button
								type="button"
								className="btn__outline apply-edit-btn"
								color="primary"
								onClick={() => {
									if (currentPath !== "edit") {
										showAuthAlert();
										return;
									} else if (!applyQuestList.title) {
										showApplyTitleAlert();
										return;
									}
									navigate("/applyForm/editfaq");
								}}
							>
								{t("pages.applyFormMange.ApplyForm.faq-edit-btn")}
							</button>
							<button
								type="button"
								className="btn__solid apply-edit-btn"
								color="primary"
								onClick={() => {
									if (currentPath !== "edit") {
										showAuthAlert();
										return;
									}
									if (!applyQuestList?.isUse) {
										showCopyCheckAlert();
										return;
									}
									if(!applyQuestList?.reviewSettingIdx) {
										showCopyCheckReviewAlert();
										return;
									}
									copyClipBoard(company.idx);
								}}
							>
								{t("pages.applyFormMange.ApplyForm.copy-btn")}
							</button>
						</div>
						{applyQuestList.title && (
							<div className="apply-desc-card">
								<h3 className="desc-title">{applyQuestList.title}</h3>
								<div className="divider" />
								{applyQuestList.description && (
									<div className="desc-text">
										{applyQuestList.description
											.split("\n")
											.map((text, index) => {
												return <p key={`desc_${index}`}>{text}</p>;
											})}
									</div>
								)}
							</div>
						)}
						{applyQuestList.qna && applyQuestList.qna.length > 0 && (
							<ViewQna question={applyQuestList.qna} />
						)}

						<ViewInquery applyForm={applyForm} applyQuestList={applyQuestList.inputs} />

						{/* <div className="form-footer">
								<div className="img-wrap">
									<img src={logoWhite} alt="로고 이미지" />
								</div>

								<p className="gitbal-explain">
									스타트업과 투자자를 연결하는 [깃발] 플랫폼에서는 스타트업의 성장을
									위해 다양한 서비스를 제공하고 있습니다. 지금 바로 경험하세요.
									<button type="button" className="btn-link">
										<a href={"https://startup.gitbal.io"}>깃발 바로가기</a>
									</button>
								</p>
						</div> */}
					</div>
				</div>
			</div>

			{/*심사항목등록*/}
			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew: "create",
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify: () => {},
					handleNewCreation,
					targetIdx,
				}}
			/>
			<ProcessAlerts
				{...{
					noCategoryAlert,
					setNoCategoryAlert,
					weightingAlert,
					setWeightingAlert,
					deleteAlertModal,
					setDeleteAlertModal,
					noEvaluationAlert,
					setNoEvaluationAlert,
					noTitleAlert,
					setNoTitleAlert,
					noCategoryName,
					setNoCategoryName,
					noItemName,
					setNoItemName,
					targetIdx,
				}}
			/>

			<ShareAlert
				type="success"
				message={t("pages.applyFormMange.ApplyForm.ShareAlertMessage")}
				confirm={t("common.commonWord.button.check")}
			/>
			<AuthAlert
				message={
					<>
						권한이 없습니다. <br />
						관리자에게 문의하세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
			<CopyCheckAlert
				message={
					<>
						Apply 양식이 비활성화 상태입니다. <br/>
						Apply 양식 수정 페이지에서 활성화로 변경해주세요.
					</>
				}
				type="warning"
				confirm="확인"
			/>
			<CopyCheckReviewAlert
				message={
					<>
						심사항목은 필수입니다.
					</>
				}
				type="warning"
				confirm="확인"
			/>
			<ApplyTitleAlert
				message={
					<>
						Apply 신청 양식 제목 입력해야
						<br /> FAQ를 등록할 수 있습니다.
					</>
				}
				type="warning"
				confirm="확인"
			/>
		</>
	);
};

export default InsertApplyForm;
